import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ConsultationThankYou.css';
import { initializeCallBooking } from '../callBookingThankYouScript.js';

const ConsultationThankYou = () => {
  useEffect(() => {
    // Add meta tags to head

    const offerMeta = document.createElement('meta');
    offerMeta.name = 'offer';
    offerMeta.content = 'Consultation';
    document.head.appendChild(offerMeta);

    // Initialize call booking
    try {
      initializeCallBooking();
    } catch (error) {
      console.error('Error initializing call booking:', error);
    }

    // Cleanup function
    return () => {
      if (document.querySelector('meta[name="offer"]')) {
        document.querySelector('meta[name="offer"]').remove();
      }
    };
  }, []);

  return (
    <div className="consultation-thank-you-container">
      <div className="thank-you-content">
        <div className="success-icon">
          💼 ✅
        </div>
        <h1>Thank You for Your Consultation Request!</h1>
        <p>I've received your consultation request and will review it carefully.</p>
        
        <div className="next-steps">
          <h3>What Happens Next?</h3>
          <ul>
            <li>I will review your consultation request within 24 hours</li>
            <li>I'll confirm if I can help with your specific situation</li>
            <li>If we're a good fit, I'll reach out to schedule our session</li>
            <li>We'll arrange a convenient time for your $400/hour consultation</li>
          </ul>
        </div>

        <div className="additional-resources">
          <h3>While You Wait</h3>
          <p>Explore our other services and resources:</p>
          <div className="resource-links">
            <Link to="/relocation-services" className="resource-link">
              View All Services
            </Link>
            <Link to="/uae" className="resource-link">
              UAE Setup Guide
            </Link>
            <Link to="/mexico-residency" className="resource-link">
              Mexico Residency
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsultationThankYou;
